import { ActionControllerEventName, ParentEvent, ResourcesManager, TextComponent, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Euler, Object3D, Quaternion, Vector2, Vector3 } from 'three';
import { SliderComponent, SlidingMode } from '../../components/SliderComponent';
import IconButtonComponent from '@verybigthings/vbt-webvr-framework/build/main/ts/components/IconButtonComponent';
import * as styleConfig from '../../styleConfig';
import { deepClone } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/DeepClone';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
export default class PipetteModule extends ViewerModule {
    constructor(level) {
        super();
        this.__inited = false;
        this.uiObject.name = 'PIPETTE_MODULE';
        this.pointerController = Viewer.pointerController;
        this.model = deepClone(ResourcesManager.getModel('micropipette_pipette').clone());
        this.addObject(this.model);
        this.level = level;
    }
    init() {
        this.display = new TextComponent({
            size: new Vector2(.3, .4),
            pxSize: new Vector2(128 * .3, 128 * .4),
            text: {
                value: '0 \n 7 \n 5',
                autoWrappingHorizontal: false,
                autoWrapping: true,
                margin: 0,
                lineHeight: 40,
                style: {
                    size: '36px'
                }
            },
            background: {
                color: 'transparent'
            }
        });
        this.display.uiObject.rotation.set(0, -Math.PI / 2, 0);
        this.display.uiObject.position.set(-.165, 0.35, -.16);
        this.addObject(this.display);
        this.setTipVisibility(false);
        this.sliderComponent = new SliderComponent({
            mode: SlidingMode.normal,
            magnetOnSides: 0.00001,
            size: {
                width: 2,
                height: 0.2
            },
            picker: new IconButtonComponent({
                diameter: 0.3,
                text: '',
                textColor: styleConfig.SLIDER_PICKER_TEXT_COLOR.getStyle(),
                background: styleConfig.SLIDER_PICKER_COLOR.getStyle()
            }),
            filledPart: {
                border: 0.02,
                radius: 0.1,
                borderColor: styleConfig.SLIDER_FILLED_COLOR,
                mainColor: styleConfig.SLIDER_FILLED_COLOR,
            },
            unfilledPart: {
                border: 0.02,
                radius: 0.1,
                borderColor: styleConfig.SLIDER_UNFILLED_BORDER_COLOR,
                mainColor: styleConfig.SLIDER_UNFILLED_COLOR,
            }
        });
        this.sliderComponent.uiObject.name = 'SliderComponent';
        this.sliderComponent.uiObject.position.set(-.12, .59, .3);
        this.sliderComponent.uiObject.rotation.set(0, -1.43, -1.57);
        this.sliderComponent.uiObject.visible = false;
        this.addObject(this.sliderComponent.uiObject);
        this.sliderPistonComponent = new SliderComponent({
            mode: SlidingMode.onlyToRight,
            magnetOnSides: 0.01,
            applyDisabled: true,
            size: {
                width: 2,
                height: 0.2
            },
            picker: new IconButtonComponent({
                diameter: 0.3,
                text: '',
                textColor: styleConfig.SLIDER_PICKER_TEXT_COLOR.getStyle(),
                background: styleConfig.SLIDER_PICKER_COLOR.getStyle()
            }),
            filledPart: {
                border: 0.02,
                radius: 0.1,
                borderColor: styleConfig.SLIDER_FILLED_COLOR,
                mainColor: styleConfig.SLIDER_FILLED_COLOR,
            },
            unfilledPart: {
                border: 0.02,
                radius: 0.1,
                borderColor: styleConfig.SLIDER_UNFILLED_BORDER_COLOR,
                mainColor: styleConfig.SLIDER_UNFILLED_COLOR,
            }
        });
        this.sliderPistonComponent.uiObject.name = 'sliderPistonComponent';
        this.sliderPistonComponent.uiObject.position.set(.72, .59, .3);
        this.sliderPistonComponent.uiObject.rotation.set(0, 0, -1.57);
        this.sliderPistonComponent.uiObject.visible = false;
        this.addObject(this.sliderPistonComponent.uiObject);
        this.pointerController.setObject(null);
        this.model.position.set(0, 0, 0);
        this.uiObject.scale.set(1, 1, 1);
        if (this.display)
            this.display.uiObject.position.set(-.165, 0.35, -.16);
        this.level.instruments.pipetteHolder.uiObject.add(this.uiObject);
        this.uiObject.rotation.set(0, Math.PI, 0);
        this.uiObject.position.set(0, .16, .34);
    }
    addToHolder() {
        this.pointerController.setObject(null);
        this.model.position.set(0, 0, 0);
        this.uiObject.scale.setScalar(1);
        if (this.display)
            this.display.uiObject.position.set(-.165, 0.35, -.16);
        ResourcesManager.getAudioManger().getAudio('put_sound').play();
        this.level.instruments.pipetteHolder.uiObject.add(this.uiObject);
        this.uiObject.position.set(0, .16, .34);
        this.uiObject.rotation.set(0, Math.PI, 0);
    }
    addToPointer() {
        if (Viewer.controls.zController)
            return;
        this.uiObject.add(this.model);
        this.uiObject.position.set(0, 0, 0);
        this.uiObject.rotation.set(0, 0, 0);
        this.pointerController.setObject(this.uiObject);
        this.display.uiObject.position.set(-.165, 1.85, -.16);
        this.model.position.set(0, 1.5, 0);
        // PreparationPickingObjects.saveObjectState(this.level.instruments.pipette.uiObject);
    }
    createClickEvent() {
        let callback;
        this.actionController.on(ActionControllerEventName.click, this.uiObject, callback = () => {
            if (!this.level.interaction)
                return;
            this.fire('pipette_clicked');
            this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
        });
    }
    setTipVisibility(value) {
        this.model.getObjectByName('pip_tip').visible = value;
    }
    applyTip() {
        this.pointerController.setObject(null);
        this.model.position.set(0, 0, 0);
        this.uiObject.scale.setScalar(1);
        this.display.uiObject.position.set(-.165, 0.35, -.16);
        this.level.instruments.tipsHolder.uiObject.add(this.uiObject);
        this.uiObject.position.set(0.14, 1.32, 0.04);
        this.uiObject.rotation.set(0, 0, 0);
        this.setTipVisibility(true);
        setTimeout(() => {
            this.tweenAnimation(this.uiObject, new Vector3(0.14, 2, 0.04), new Euler(0, 0, 0), undefined, () => this.fire('tip_applied'));
        }, 400);
    }
    initAdjusting() {
        this.uiObject.position.set(-3.14, -1.686, 1.33);
        this.uiObject.rotation.set(0, 0, 0);
        this.level.uiContainer.add(this.uiObject);
        const scaleModel = Viewer.controls.zController ? 3 : 1;
        this.tweenAnimation(this.uiObject, new Vector3(0, -1.32, 0), new Euler(0, Math.PI / 2, 0), scaleModel, () => this.fire('ready_to_adjust'));
    }
    tweenAnimation(model, newPosition, newRotation, newScaleValue, onComplete) {
        if (newScaleValue === undefined)
            newScaleValue = model.scale.x;
        const startScale = model.scale.x;
        const diffScale = newScaleValue - model.scale.x;
        const oldPos = model.position.clone();
        const oldRotation = new Quaternion().setFromEuler(model.rotation.clone());
        const newPos = newPosition;
        const newRot = new Quaternion();
        newRot.setFromEuler(newRotation);
        const tween = new Tween({ alpha: 0 }).to({ alpha: 1 }, 1000)
            .onUpdate((alpha) => {
            const currentPos = oldPos.clone().lerp(newPos, alpha);
            Quaternion.slerp(oldRotation, newRot, model.quaternion, alpha);
            model.position.copy(currentPos);
            model.scale.setScalar(startScale + diffScale * alpha);
        })
            .onComplete(onComplete ? onComplete : () => { })
            .start();
    }
    initSlider() {
        let currSliderValue = 0;
        let prevSliderValue = 0;
        this.sliderComponent.value = 0;
        this.sliderComponent.uiObject.visible = true;
        const knob = this.model.getObjectByName('pip_knob');
        let curentVolume = 75;
        const onChangePipetteVolume = (eventData) => {
            if (eventData === 1000)
                return;
            currSliderValue = eventData;
            knob.rotation.z = eventData * 10;
            prevSliderValue = eventData;
            prevSliderValue = prevSliderValue * 500 + 750;
            const firstNumber = Math.floor((prevSliderValue / 10) % 10);
            const secondNumber = Math.floor((prevSliderValue / 100) % 10);
            const thirdNumber = Math.floor((prevSliderValue / 1000) % 10);
            curentVolume = firstNumber + secondNumber * 10 + thirdNumber * 100;
            this.display.setText('' + thirdNumber + ' \n ' + secondNumber + ' \n ' + firstNumber);
            this.fire('filling', new ParentEvent('filling', eventData));
        };
        this.sliderComponent.on('change', (event) => onChangePipetteVolume(event.data));
        let onMinusPipetteVolume;
        let onPlusPipetteVolume;
        if (Viewer.controls.zController) {
            this.sliderComponent.uiObject.children[0].visible = false;
            this.sliderComponent.uiObject.children[2].visible = false;
            this.sliderComponent.uiObject.children[3].visible = false;
            const step = 0.02;
            Viewer.zSpaceControls.on('buttonRightDown', onMinusPipetteVolume = () => {
                if (currSliderValue - step >= 0)
                    onChangePipetteVolume(currSliderValue - step);
                const minusPipetteVolumeInterval = setInterval(() => {
                    if (currSliderValue - step >= 0)
                        onChangePipetteVolume(currSliderValue - step);
                }, 300);
                Viewer.zSpaceControls.once('buttonRightUp', () => clearInterval(minusPipetteVolumeInterval));
            });
            Viewer.zSpaceControls.on('buttonLeftDown', onPlusPipetteVolume = () => {
                if (currSliderValue + step <= 1)
                    onChangePipetteVolume(currSliderValue + step);
                const plusPipetteVolumeInterval = setInterval(() => {
                    if (currSliderValue + step <= 1)
                        onChangePipetteVolume(currSliderValue + step);
                }, 300);
                Viewer.zSpaceControls.once('buttonLeftUp', () => clearInterval(plusPipetteVolumeInterval));
            });
        }
        this.sliderComponent.on('completed', () => {
            if (!this.level.interaction)
                return;
            if (curentVolume !== 100) {
                this.fire('not_full', new ParentEvent('not_full', { tooMuch: (curentVolume > 100) }));
            }
            if (Viewer.controls.zController) {
                this.uiObject.userData.pcScale = this.uiObject.scale.x;
                this.uiObject.scale.setScalar(2);
                Viewer.zSpaceControls.off('buttonLeftDown', onPlusPipetteVolume);
                Viewer.zSpaceControls.off('buttonRightDown', onMinusPipetteVolume);
            }
            else {
                this.uiObject.userData.zsScale = 2;
            }
            this.sliderComponent.uiObject.visible = false;
            this.initPickingEvent();
            this.fire('adjustment_completed');
        });
    }
    initPickingEvent() {
        this.uiObject.traverse(el => {
            if (el.userData.oldRaycast)
                el.raycast = el.userData.oldRaycast;
        });
        if (this.level.lobby.app.zSpacePickingController) {
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.uiObject, () => {
                if (!this.level.interaction)
                    return;
                Viewer.scene.add(this.uiObject);
                this.uiObject.traverse(el => {
                    el.userData.oldRaycast = el.raycast;
                    el.raycast = () => { };
                });
            });
        }
    }
    initFilling() {
        this.pointerController.setObject(null);
        this.model.position.set(0, 0, 0);
        this.uiObject.userData.zsScale = undefined;
        this.uiObject.scale.setScalar(1);
        this.display.uiObject.position.set(-.165, 0.35, -.16);
        this.uiObject.position.set(0, -1.577, 2.115);
        this.uiObject.rotation.set(0, 0, 0);
        this.level.uiContainerObjects.add(this.uiObject);
        this.tweenAnimation(this.uiObject, new Vector3(0, -2.25, 2.115), new Euler(0, 0, 0), undefined, () => this.fire('ready_to_fill'));
    }
    animateButton() {
        const button = this.model.getObjectByName('pip_button');
        this.sliderPistonComponent.value = 0.00001;
        this.sliderPistonComponent.init();
        this.sliderPistonComponent.uiObject.visible = true;
        if (Viewer.controls.zController) {
            this.uiObject.userData.pcParent = this.uiObject.parent;
            this.sliderPistonComponent.uiObject.userData.pcParent = this.sliderPistonComponent.uiObject.parent;
            this.sliderPistonComponent.uiObject.userData.pcPosition = this.sliderPistonComponent.uiObject.position.clone();
            this.sliderPistonComponent.uiObject.userData.pcScale = this.sliderPistonComponent.uiObject.scale.x;
            this.level.uiContainerObjects.add(this.uiObject);
            this.level.uiContainer.add(this.sliderPistonComponent.uiObject);
            this.sliderPistonComponent.uiObject.position.set(1.2, -2.4, 0);
            this.sliderPistonComponent.uiObject.scale.setScalar(2);
        }
        else {
            this.uiObject.userData.zsParent = this.level.uiContainerObjects;
            this.sliderPistonComponent.uiObject.userData.zsParent = this.level.uiContainer;
            this.sliderPistonComponent.uiObject.userData.zsPosition = new Vector3(1.2, -2.4, 0);
            this.sliderPistonComponent.uiObject.userData.zsScale = 2;
        }
        const oldPosition = new Vector3(0, .98, -.18);
        this.sliderPistonComponent.on('change', (event) => {
            const currentPosition = oldPosition.clone().lerp(new Vector3(0, .69, -.18), event.data);
            button.position.copy(currentPosition);
        });
        let plusPistonPipetteVolumeEvent;
        if (Viewer.controls.zController) {
            this.sliderPistonComponent.uiObject.children[0].visible = false;
            let startVal = -1;
            Viewer.zSpaceControls.on('buttonLeftDown', plusPistonPipetteVolumeEvent = () => {
                this.sliderPistonComponent.moveEvent(new Vector3(startVal += 0.1, 0, 0));
                const plusPistonPipetteVolumeInterval = setInterval(() => {
                    this.sliderPistonComponent.moveEvent(new Vector3(startVal += 0.1, 0, 0));
                }, 300);
                Viewer.zSpaceControls.once('buttonLeftUp', () => clearInterval(plusPistonPipetteVolumeInterval));
            });
        }
        this.sliderPistonComponent.on('completed', () => {
            if (!this.level.interaction)
                return;
            if (button.position.y !== .69)
                return;
            this.sliderPistonComponent.off('completed');
            this.sliderPistonComponent.uiObject.visible = false;
            this.pointerController.setObject(new Object3D());
            this.tweenAnimation(button, new Vector3(0, .98, -.18), new Euler(-0.1, 0, 0), undefined, () => {
                this.initPickingEvent();
                if (Viewer.zSpaceControls)
                    Viewer.zSpaceControls.off('buttonLeftDown', plusPistonPipetteVolumeEvent);
                this.fire('pipette_button_clicked');
            });
        });
    }
    initDevastation() {
        this.pointerController.setObject(null);
        this.model.position.set(0, 0, 0);
        this.uiObject.scale.setScalar(1);
        this.display.uiObject.position.set(-.165, 0.35, -.16);
        this.uiObject.position.set(2.25, -1.577, -.18);
        this.uiObject.rotation.set(0, 0, 0);
        this.level.uiContainerObjects.add(this.uiObject);
        this.tweenAnimation(this.uiObject, new Vector3(2.25, -2.25, -.18), new Euler(0, 0, 0), undefined, () => this.fire('ready_to_devastate'));
    }
    initTrashTip() {
        this.pointerController.setObject(null);
        this.uiObject.scale.setScalar(1);
        this.model.position.set(0, 0, 0);
        this.display.uiObject.position.set(-.165, 0.35, -.16);
        this.uiObject.position.set(4.36, -.7, -2.18);
        this.uiObject.rotation.set(0, 0, 0);
        this.level.uiContainerObjects.add(this.uiObject);
        const tip = this.model.getObjectByName('pip_tip');
        // attachTransformControls(button);
        this.tweenAnimation(tip, new Vector3(0, -3, 0), new Euler(0, 0, 0), undefined, () => {
            this.initPickingEvent();
            this.fire('tip_trashed');
        });
    }
}
